import { createApp, ref } from 'vue';
import common from '@page/common/js/common';
import Favorite from '@page/favorite/components/Favorite.vue';

const app = createApp({
  components: {
    Favorite,
  },
});

app.mount('#app-favorite');
